let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("34ODX")).then(() => parcelRequire('jQbxP'));